import { Link } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { CATEGORIES, TOOLS } from '@/lib/tools';
import { FOOTER } from '@/constants/testIds';

export function Footer() {
    const liveTools = TOOLS.filter((t) => t.status === 'live');
    return (
        <footer className="mt-20 border-t border-border/70 bg-white">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-2 md:grid-cols-4 gap-8">
                <div className="col-span-2 md:col-span-1">
                    <Link to="/" className="flex items-center gap-2">
                        <span className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-[hsl(var(--primary))] text-white shadow-sm">
                            <Sparkles className="w-4 h-4" />
                        </span>
                        <span className="font-semibold text-slate-900">UtilityTool</span>
                    </Link>
                    <p className="mt-3 text-sm text-slate-600 leading-relaxed max-w-xs">
                        Fast, private online utility tools built for everyday work. No
                        signup required, and your files are deleted from our servers after
                        processing.
                    </p>
                </div>

                <div>
                    <h4 className="text-sm font-semibold text-slate-900">Tools</h4>
                    <ul className="mt-3 space-y-2 text-sm">
                        {liveTools.map((t) => (
                            <li key={t.slug}>
                                <Link
                                    to={`/tools/${t.slug}`}
                                    className="text-slate-600 hover:text-slate-900"
                                >
                                    {t.title}
                                </Link>
                            </li>
                        ))}
                        <li>
                            <Link
                                to="/tools"
                                data-testid={FOOTER.toolsLink}
                                className="text-slate-600 hover:text-slate-900"
                            >
                                All tools
                            </Link>
                        </li>
                    </ul>
                </div>

                <div>
                    <h4 className="text-sm font-semibold text-slate-900">Categories</h4>
                    <ul className="mt-3 space-y-2 text-sm">
                        {CATEGORIES.map((c) => (
                            <li key={c.id}>
                                <Link
                                    to={`/tools?category=${c.id}`}
                                    className="text-slate-600 hover:text-slate-900"
                                >
                                    {c.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <div>
                    <h4 className="text-sm font-semibold text-slate-900">Company</h4>
                    <ul className="mt-3 space-y-2 text-sm">
                        <li>
                            <Link to="/about" data-testid={FOOTER.aboutLink} className="text-slate-600 hover:text-slate-900">
                                About us
                            </Link>
                        </li>
                        <li>
                            <Link to="/contact" data-testid={FOOTER.contactLink} className="text-slate-600 hover:text-slate-900">
                                Contact
                            </Link>
                        </li>
                        <li>
                            <Link to="/blog" data-testid={FOOTER.blogLink} className="text-slate-600 hover:text-slate-900">
                                Blog
                            </Link>
                        </li>
                        <li>
                            <Link to="/privacy-policy" data-testid={FOOTER.privacyLink} className="text-slate-600 hover:text-slate-900">
                                Privacy Policy
                            </Link>
                        </li>
                        <li>
                            <Link to="/terms-of-service" data-testid={FOOTER.termsLink} className="text-slate-600 hover:text-slate-900">
                                Terms of Service
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-border/70">
                <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-slate-500">
                    <p>© {new Date().getFullYear()} UtilityTool · Johannesburg, South Africa · Built for people who want small tools that just work.</p>
                    <p>
                        Questions? <a href="mailto:hello@utilitytool.co.za" className="text-slate-700 hover:text-slate-900 underline underline-offset-2">hello@utilitytool.co.za</a>
                    </p>
                </div>
            </div>
        </footer>
    );
}
